/* pet.js — PET product page theme (v2): critters, reveal, stamp, ticker helpers */
(function () {
  'use strict';

  var root = document.documentElement;
  var skin = document.querySelector('[data-pt-skin]');

  /* ── Announcement bar: PET messages (only with chrome on) ── */
  if (skin && root.classList.contains('pet-chrome')) {
    var msgs = (skin.dataset.ann || '').split('||').map(function (s) { return s.trim(); }).filter(Boolean);
    var slides = document.querySelectorAll('.announcement__slide .announcement__text > span:first-child');
    if (msgs.length && slides.length) {
      slides.forEach(function (s, i) { s.textContent = msgs[i % msgs.length]; });
    }
  }

  /* ── Icon source (from the skin <template>) ─────────────── */
  var iconTpl = document.querySelector('template[data-pt-icons]');
  var ICON = {};
  if (iconTpl) iconTpl.content.querySelectorAll('[data-icon]').forEach(function (i) { ICON[i.dataset.icon] = i.innerHTML; });

  /* ── Scudetto theme: drop the name/number personalization block on PET ── */
  document.querySelectorAll('.personalizacao').forEach(function (el) { el.remove(); });

  /* ── Size picker: dog grows with the chosen size + guide link ── */
  var rowHead = document.querySelector('.pdp__row-head');
  var variantInputs = document.querySelectorAll('.pdp__sizes input[data-variant]');
  var scPicker = document.querySelector('.product-detail__variant-picker');
  if (!rowHead && scPicker) {
    /* Scudetto: build a host row above the swatches */
    var host = document.createElement('div');
    host.className = 'pt-pick--sc';
    scPicker.insertBefore(host, scPicker.firstChild);
    rowHead = host;
    variantInputs = scPicker.querySelectorAll('input[type="radio"]');
  }
  if (rowHead && variantInputs.length > 1 && ICON.dog) {
    var pick = document.createElement('span');
    pick.className = 'pt-pick';
    pick.innerHTML = '<i class="pt-pick__dog" aria-hidden="true">' + ICON.dog + '</i>' +
      (document.getElementById('pet-sizes') ? '<a class="pt-pick__guide" href="#pet-sizes">' + (ICON.paw || '') + '<span class="pt-pick__guide-txt"></span></a>' : '');
    var guideTxt = pick.querySelector('.pt-pick__guide-txt');
    if (guideTxt) guideTxt.textContent = (skin && skin.dataset.guideLabel) || 'Size guide';
    rowHead.appendChild(pick);
    var dog = pick.querySelector('.pt-pick__dog');
    var sizeCount = variantInputs.length;
    function setDog(bump) {
      var idx = 0;
      variantInputs.forEach(function (inp, i) { if (inp.checked) idx = i; });
      var k = 0.5 + 0.5 * (idx / (sizeCount - 1));
      dog.style.setProperty('--k', k.toFixed(3));
      if (bump) { dog.classList.remove('is-bump'); void dog.offsetWidth; dog.classList.add('is-bump'); }
    }
    setDog(false);
    variantInputs.forEach(function (inp) { inp.addEventListener('change', function () { setDog(true); }); });
  }

  /* ── Paw burst on Add to Cart ───────────────────────────── */
  function burst(x, y) {
    if (!ICON.paw) return;
    for (var i = 0; i < 8; i++) {
      var p = document.createElement('span');
      p.className = 'pt-burst';
      p.innerHTML = ICON.paw;
      var ang = (Math.PI * 2 * i) / 8 + (Math.random() - 0.5) * 0.6;
      var dist = 60 + Math.random() * 50;
      p.style.left = x + 'px'; p.style.top = y + 'px';
      p.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(0) + 'px');
      p.style.setProperty('--dy', (Math.sin(ang) * dist - 20).toFixed(0) + 'px');
      p.style.setProperty('--rot', ((Math.random() - 0.5) * 120).toFixed(0) + 'deg');
      document.body.appendChild(p);
      setTimeout(function (el) { el.remove(); }, 900, p);
    }
  }
  document.querySelectorAll('.pdp__atc, .pdp__floatatc-btn, .product-form__submit').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var r = btn.getBoundingClientRect();
      burst(e.clientX || r.left + r.width / 2, e.clientY || r.top + r.height / 2);
      btn.classList.remove('is-bounce'); void btn.offsetWidth; btn.classList.add('is-bounce');
    });
  });

  /* ── Reveal on scroll ───────────────────────────────────── */
  var reveals = document.querySelectorAll('.pt-reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); obs.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 60px 0px' });
    reveals.forEach(function (el) { obs.observe(el); });
    /* Safety net: never leave content hidden if the observer doesn't fire */
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-visible'); }); }, 3000);
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ── Stamp intro cleanup ────────────────────────────────── */
  var stamp = document.querySelector('.pt-stamp');
  if (stamp && !root.classList.contains('pet-seen')) {
    var dur = parseInt(getComputedStyle(stamp).getPropertyValue('--pt-intro'), 10) || 2600;
    setTimeout(function () { stamp.remove(); root.classList.add('pet-ready'); }, dur + 150);
  } else {
    if (stamp) stamp.remove();
    root.classList.add('pet-ready');
  }

  /* ── Critters: scattered paws, bones, balls, mice… ──────── */
  var tpl = document.querySelector('template[data-pt-icons]');
  var wantCritters = skin && skin.dataset.critters === 'true' && tpl;
  if (wantCritters && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var icons = ICON;

    var density = parseInt(skin.dataset.crittersDensity, 10) || 34;
    var baseOpacity = (parseInt(skin.dataset.crittersOpacity, 10) || 16) / 100;

    /* Seeded RNG so the layout is stable between reloads */
    var seed = 1924;
    function rnd() { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }
    function between(a, b) { return a + rnd() * (b - a); }
    function pick(arr) { return arr[Math.floor(rnd() * arr.length)]; }

    var weighted = ['paw','paw','paw','paw','bone','bone','ball','tennis','mouse','fish','tag','bowl','heart'];
    var colors = ['#C97020','#C97020','#C97020','#9A5E2A','#9A5E2A','#3F7A2A'];

    var field = document.createElement('div');
    field.className = 'pt-field';
    field.setAttribute('aria-hidden', 'true');

    var mobile = window.innerWidth < 700;
    var n = mobile ? Math.round(density * 0.45) : density;

    for (var i = 0; i < n; i++) {
      var name = pick(weighted);
      var el = document.createElement('span');
      el.className = 'pt-critter';
      el.innerHTML = icons[name] || icons.paw;

      var gutter = !mobile && rnd() < 0.7;
      var x, o;
      if (gutter) {
        x = rnd() < 0.5 ? between(0.6, 8.5) : between(91, 98);
        o = baseOpacity;
      } else {
        x = between(10, 88);
        o = baseOpacity * (mobile ? 0.7 : 0.5);
      }
      var y = between(3, 97);
      var s = Math.round(between(18, 46));

      el.style.setProperty('--s', s + 'px');
      el.style.setProperty('--o', o.toFixed(3));
      el.style.setProperty('--r', Math.round(between(-40, 40)) + 'deg');
      el.style.setProperty('--c', pick(colors));
      el.style.setProperty('--d', between(5, 10).toFixed(1) + 's');
      el.style.setProperty('--dl', (-between(0, 8)).toFixed(1) + 's');
      el.style.left = x.toFixed(2) + '%';
      el.style.top = y.toFixed(2) + '%';
      field.appendChild(el);
    }

    function sizeField() { field.style.height = root.scrollHeight + 'px'; }
    document.body.appendChild(field);
    sizeField();
    window.addEventListener('load', sizeField);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sizeField, 150); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { sizeField(); }).observe(document.body);
  }

  /* ── Tickers: pixel-exact infinite loop ─────────────────── */
  document.querySelectorAll('[data-pt-ticker]').forEach(function (ticker) {
    var track = ticker.querySelector('.pt-ticker__track');
    var groups = track.querySelectorAll('.pt-ticker__group');
    if (!track || groups.length < 2) return;
    var pxPerSec = parseInt(ticker.dataset.speed, 10) || 55;

    function build() {
      /* keep only the original 2 groups, then clone until we cover 2 screens + 1 group */
      track.querySelectorAll('.pt-ticker__group[data-clone]').forEach(function (g) { g.remove(); });
      var w = groups[0].getBoundingClientRect().width;
      if (!w) return;
      var need = Math.ceil((ticker.clientWidth * 2) / w) + 1;
      for (var i = groups.length; i < need; i++) {
        var c = groups[1].cloneNode(true);
        c.setAttribute('data-clone', '1');
        track.appendChild(c);
      }
      track.style.setProperty('--pt-w', w + 'px');
      track.style.setProperty('--pt-dur', (w / pxPerSec).toFixed(2) + 's');
      ticker.classList.add('is-measured');
    }
    build();
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 200); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
  });

  /* ── Hero photo: gentle mouse parallax (desktop only) ───── */
  var media = document.querySelector('.pt-hero__media');
  if (media && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mousemove', function (e) {
      var mx = (e.clientX / window.innerWidth - 0.5) * 10;
      var my = (e.clientY / window.innerHeight - 0.5) * 8;
      media.style.transform = 'translate(' + mx.toFixed(1) + 'px,' + my.toFixed(1) + 'px)';
    }, { passive: true });
  }
})();
